function getIntensityIcon(level) {
  switch (level?.toLowerCase()) {
    case "niedrig":
      return "⬇⬇";
    case "mittel":
      return "➡";
    case "hoch":
      return "⬆⬆";
    default:
      return "";
  }
}

export default getIntensityIcon;